import React, { useState } from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { useDragScroll } from '_ui-core-js/React/hooks/useDragScroll.js';
import { fireGTMTrackingEvent } from '_ui-core-js/utilities/fireGTMTrackingEvent.js';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';
import { RANGE_GTM_TRACKING_VALUES } from '../../../../../range/ui/constants/analytics.js';

export function RangeFilters(props) {
	
    const { filtersData, closeConfiguratorCallback, openConfiguratorCallback, showToggle } = props;
    const block = 'c-range-filters';
    const [isOverflowing, setIsOverflowing] = useState();
    const dragEvents = useDragScroll({ 
      onScrollCallback: scrollPosition => {
        setIsOverflowing(scrollPosition !== 'end');
      },
    });

    return (
      <nav className={block}>
				<div 
        className={classNames({
          [`${block}__filters`]: true,
          [`${block}__filters--is-overflowing`]: isOverflowing
        })}
        { ...dragEvents }
        >
					<ul role='tablist' className={`${block}__filters__tabs`}>
          {
            Object.keys(filtersData).map(key => (
              <li key={filtersData[key].name}>
                <button
								id={filtersData[key].name}
								className={`${block}__filters__tab`}
								data-classification-id={key}
								role='tab'
								aria-selected={props.activeClassificationId === key}
								tabIndex='0'
								onClick={e => {
                  fireGTMTrackingEvent({
                    name: CORE_GTM_TRACKING_VALUES.name.componentEvent,
                    componentName: props.useGrades ? RANGE_GTM_TRACKING_VALUES.componentName.gradeRange + '-' + props.baseModelName : RANGE_GTM_TRACKING_VALUES.componentName.modelRange,
                    componentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
                    action: CORE_GTM_TRACKING_VALUES.action.clickTab,
                    label: filtersData[key].name
                  })

                  props.updateFilterSelectionCallback(e.currentTarget.dataset.classificationId)
                }}
							  >
                  {filtersData[key].name}	&nbsp; ({filtersData[key].count})
							  </button>
              </li>
            ))
          }
					</ul>
					<select 
					className={`${block}__filters__select`} 
					onChange={e => props.updateFilterSelectionCallback(e.target.value)}
					>
					{
						Object.keys(filtersData).map(key => (
							<option key={filtersData[key].name} value={key}>
								{filtersData[key].name}
								&nbsp;
								({filtersData[key].count})
							</option>
						))
					}
					</select>
				</div>
        {
          showToggle &&
            <div role='tablist' className={`${block}__configurator-toggle`}>
              <button
                role='tab'
                aria-selected={!props.toggleViewDependency}
                id='close-configurator'
                tabIndex={`${props.toggleViewDependency ? '0' : '-1' }`}
                onClick={closeConfiguratorCallback}
                className={`${block}__configurator-toggle__toggle`}
              >
              <img
                src='../../resources/images/range-view.svg'
                alt='Detail View'
              />
              </button>
              <button
                role='tab'
                aria-selected={props.toggleViewDependency}
                id='open-configurator'
                tabIndex={`${props.toggleViewDependency ? '-1' : '0' }`}
                onClick={openConfiguratorCallback}
                className={`${block}__configurator-toggle__toggle`}
              >
              <img
                src='../../resources/images/detail-view.svg'
                alt='Detail View'
              />
              </button>
            </div>
        }
				
      </nav>
    );
};

RangeFilters.propTypes = {
	filtersData: propTypes.object.isRequired,
	activeClassificationId: propTypes.string.isRequired,
	updateFilterSelectionCallback: propTypes.func.isRequired,
	openConfiguratorCallback: propTypes.func.isRequired,
	closeConfiguratorCallback: propTypes.func.isRequired,
	toggleViewDependency: propTypes.bool.isRequired,
  showToggle: propTypes.bool,
  useGrades: propTypes.bool,
  modelName: propTypes.string,
  baseModelName: propTypes.string,
};

RangeFilters.defaultProps = { 
  showToggle: true
};
